import { render } from "./PersonSearch.vue?vue&type=template&id=446ec127"
import script from "./PersonSearch.vue?vue&type=script&lang=js"
export * from "./PersonSearch.vue?vue&type=script&lang=js"

import "./PersonSearch.vue?vue&type=style&index=0&id=446ec127&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__